import React from 'react';
import './App.css';
import './styles/globals.css';
import "./styles/fonts.css";

import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import PortfolioSection from './components/PortfolioSection';
import ProblemSolutionSection from './components/ProblemSolutionSection';
import ReviewsSection from './components/ReviewsSection';
import FAQSection from './components/FAQSection';
import Career from './components/Career';
import ContactPage from './components/ContactPage';

import ScrollToTop from './components/ScrollToTop';  // ⭐ ADDED
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>

      {/* ⭐ THIS ENSURES EVERY ROUTE LOADS AT THE TOP */}
      <ScrollToTop />

      <Navbar />

      <Routes>

        {/* HOME PAGE */}
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <AboutSection />
              <ServicesSection />
              <ProcessSection />
              <PortfolioSection />
              <ProblemSolutionSection />
              <ReviewsSection />
              <FAQSection />
            </>
          }
        />

        {/* OTHER PAGES */}
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/career" element={<Career />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
